import React from "react";
import { Dialog, DialogTitle, DialogBody } from "./tailwind/dialog";

export default function ErrorModal({ open, onClose, errorType, errorMessage }) {
  const errorMessageContent =
    errorType === "duplicate"
      ? "Campaign duplication failed after multiple attempts. Please try again in a few moments. If the problem persists, contact support."
      : errorMessage;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Campaign Duplication Error</DialogTitle>
      <DialogBody>
        <p>{errorMessageContent}</p>
      </DialogBody>
    </Dialog>
  );
}
